"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./Products.css");

var _react = _interopRequireDefault(require("react"));

var _MobxView = _interopRequireDefault(require("../../higher-order/MobxView"));

var _MarketingPageContent = _interopRequireDefault(require("../components/MarketingPageContent"));

var _MarketingHero = _interopRequireDefault(require("../components/MarketingHero"));

var _CustomizeBenefits = _interopRequireDefault(require("../components/CustomizeBenefits"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _ProductStore = _interopRequireDefault(require("../models/ProductStore"));

var _MarketingProductNavbar = _interopRequireDefault(require("../components/MarketingProductNavbar"));

var _MarketingVideoHelpers = require("../components/MarketingVideoHelpers");

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _OnboardingCard = _interopRequireDefault(require("../components/products/OnboardingCard"));

var _BulletPoint = _interopRequireDefault(require("../components/BulletPoint"));

var _map = _interopRequireDefault(require("lodash/map"));

var _constants = require("../../util/constants");

var _HomeStore = require("../models/HomeStore");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SOLUTIONS_BULLET_KEYS = ["suiteSolutionBullet1", "suiteSolutionBullet2", "suiteSolutionBullet3"];
var PRODUCT_CARDS = [{
  className: "fincore",
  title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "FINANCIAL ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "Core")),
  bodyText: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Give employees access to a financial wellness platform that can help them ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "take control of their financial well-being.")),
  image: require("../assets/redesign2020/products/fincore-lifestyle.png"),
  imageAlt: "Financial Core",
  productHref: _constants.URLS.MARKETING.REFI,
  bulletContentKeys: ["fincoreBullet1", "fincoreBullet2", "fincoreBullet3"]
}, {
  className: "slp",
  title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "STUDENT LOAN ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "PayDown")),
  bodyText: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Help your employees ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "pay down their student loan debt faster"), " through direct contributions towards their student loans so they can focus on their next financial goal."),
  image: require("../assets/redesign2020/products/slp-lifestyle.png"),
  imageAlt: "Student Loan Paydown",
  productHref: _constants.URLS.MARKETING.PAYDOWN,
  bulletContentKeys: ["slpBullet1", "slpBullet2", "slpBullet3"]
}, {
  className: "csu",
  title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "COLLEGE ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "SaveUp")),
  bodyText: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Help your employees ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "save for their children's education"), " with direct contributions to their 529 college savings plans."),
  image: require("../assets/redesign2020/products/csu-lifestyle.png"),
  imageAlt: "College Save Up",
  productHref: _constants.URLS.MARKETING.SAVEUP,
  bulletContentKeys: ["csuBullet1", "csuBullet2", "csuBullet3"]
}];
var ENROLLMENT_BULLET_KEYS = ["enrollmentBullet1", "enrollmentBullet2", "enrollmentBullet3", "enrollmentBullet4"];
var LEGAL_TEXT_KEYS = ["legalText1"];
var PRODUCT_NAVBAR_DESKTOP_DISTANCE = 665;
var PRODUCT_NAVBAR_TABLET_DISTANCE = 406;

var Products = /*#__PURE__*/function (_React$Component) {
  _inherits(Products, _React$Component);

  var _super = _createSuper(Products);

  function Products() {
    _classCallCheck(this, Products);

    return _super.apply(this, arguments);
  }

  _createClass(Products, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_MarketingPageContent.default, {
        enableSubfooter: true,
        legalTextKeys: LEGAL_TEXT_KEYS
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-products"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "hero-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "background",
        className: "background-triangle",
        src: require("../assets/redesign2020/products/background-triangle.svg")
      }), /*#__PURE__*/_react.default.createElement(_MarketingHero.default, {
        desktopImage: require("../assets/redesign2020/products/desktop-hero.png"),
        tabletImage: require("../assets/redesign2020/products/tablet-hero.png"),
        mobileImage: require("../assets/redesign2020/products/mobile-hero.png"),
        containsChevron: true
      }, /*#__PURE__*/_react.default.createElement("span", null, "Financial "), /*#__PURE__*/_react.default.createElement("span", null, "wellness "), /*#__PURE__*/_react.default.createElement("span", {
        className: "benefits"
      }, "benefits "), /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "that "), /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted works"
      }, "work for all", /*#__PURE__*/_react.default.createElement("span", {
        className: "period"
      }, ".")), /*#__PURE__*/_react.default.createElement("span", {
        className: "subtitle"
      }, "Our solutions meet your employees where they are, to help get them where they want to be."))), /*#__PURE__*/_react.default.createElement(_MarketingProductNavbar.default, {
        tabletTop: PRODUCT_NAVBAR_TABLET_DISTANCE,
        desktopTop: PRODUCT_NAVBAR_DESKTOP_DISTANCE
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "suite-solutions"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "solutions-header"
      }, "Gradifi ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "Suite of Solutions")), /*#__PURE__*/_react.default.createElement("div", {
        className: "solutions-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "solutions-body-text-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "suiteSolutionBody",
        className: "solutions-body-text"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "solutions-list-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "div",
        contentKey: "suiteSolutionListTitle",
        className: "solutions-list-title"
      }), /*#__PURE__*/_react.default.createElement("ul", {
        className: "solutions-list"
      }, (0, _map.default)(SOLUTIONS_BULLET_KEYS, function (contentKey) {
        return /*#__PURE__*/_react.default.createElement(_BulletPoint.default, {
          key: contentKey,
          contentKey: contentKey,
          className: "solutions-list-item"
        });
      }))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "product-cards"
      }, (0, _map.default)(PRODUCT_CARDS, function (_ref) {
        var className = _ref.className,
            title = _ref.title,
            image = _ref.image,
            imageAlt = _ref.imageAlt,
            bodyText = _ref.bodyText,
            bulletContentKeys = _ref.bulletContentKeys,
            productHref = _ref.productHref;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: className,
          key: className
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "product-image-wrapper"
        }, /*#__PURE__*/_react.default.createElement("img", {
          className: "product-image",
          alt: imageAlt,
          src: image
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "product-body"
        }, /*#__PURE__*/_react.default.createElement("h2", {
          className: "product-header"
        }, title), /*#__PURE__*/_react.default.createElement("h3", {
          className: "product-body-text"
        }, bodyText), /*#__PURE__*/_react.default.createElement("ul", {
          className: "product-list"
        }, (0, _map.default)(bulletContentKeys, function (contentKey) {
          return /*#__PURE__*/_react.default.createElement(_BulletPoint.default, {
            key: contentKey,
            contentKey: contentKey,
            className: "product-list-text",
            superScript: contentKey === "slpBullet1" ? "legal-text-1" : ""
          });
        }))), /*#__PURE__*/_react.default.createElement("a", {
          href: productHref,
          className: "button"
        }, "LEARN MORE"));
      })), /*#__PURE__*/_react.default.createElement(_CustomizeBenefits.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "onboard-security"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "onboard-security-background",
        "aria-hidden": "true",
        alt: "",
        src: require("../assets/redesign2020/products/onboarding-background.svg")
      }), /*#__PURE__*/_react.default.createElement(_OnboardingCard.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "security-card"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: require("../assets/redesign2020/products/security.png"),
        alt: "Security is at the heart of our platform",
        className: "security-image"
      }), /*#__PURE__*/_react.default.createElement("h2", {
        className: "security-header"
      }, "Security is ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "the heart of our platform"), "."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "securitySummary",
        className: "security-body"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "enrollment"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: require("../assets/redesign2020/products/enrollment-triangle.svg"),
        className: "enrollment-background-image",
        alt: ""
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "enrollment-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "enrollment-image-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: require("../assets/redesign2020/products/enrollment.png"),
        className: "enrollment-image",
        alt: "Enrollment is just the beginning"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "enrollment-body"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "enrollment-header"
      }, "Enrollment is ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "just the beginning"), "."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "enrollmentBodyText",
        className: "enrollment-body-text"
      }), /*#__PURE__*/_react.default.createElement("ul", {
        className: "enrollment-list"
      }, (0, _map.default)(ENROLLMENT_BULLET_KEYS, function (bulletKey) {
        return /*#__PURE__*/_react.default.createElement(_BulletPoint.default, {
          key: bulletKey,
          contentKey: bulletKey,
          className: "enrollment-list-item"
        });
      }))))), (0, _MarketingVideoHelpers.renderMarketingTestimonial)(this.props.videoModals[_HomeStore.ANDERSEN_TAX_VIDEO_KEY])));
    }
  }]);

  return Products;
}(_react.default.Component);

var propulateView = (0, _Propulator.default)(Products, {
  productStore: ["videoModals"]
});

var _default = (0, _MobxView.default)(propulateView, {
  ProductStore: _ProductStore.default
});

exports.default = _default;